import React from "react";
import "../styles/ParagraphLeft.css";

function ParagraphLeft() {

    return (
        <div className="container-fluid paragraph-left-section-background my-5-5 py-5 text-white">
            <div className="container">
                <h4 className="fs-2">Restauracja Sami Swoi</h4>
                <hr className="divider" />
                <p className="fw-light">Restauracja Sami Swoi jest miejscem spotkań, gdzie można zjeść nie tylko dania tradycyjnej polskiej kuchni. W naszej ofercie mamy również znakomitą pizzę. Dzięki zdobywanemu doświadczeniu cały czas poszerzamy swoje horyzonty. Jesteśmy oddanym zespołem kucharzy i kelnerów, którzy nie boją się wyzwań i chętnie podejmujemy nowe zlecenia. Mamy wiele ciekawych pomysłów, realizujemy wszystkie. Dążymy do tego, aby każdy odwiedzający nas Gość był zadowolony z jakości naszych usług i chętnie do nas wracał.</p>
            </div>
        </div>
    )

}

export default ParagraphLeft;